/**
 * Validates that all required fields in a drawdown object are non-empty strings.
 *
 * @param {Object} drawdown - The drawdown object to validate.
 * @param {string} drawdown.value - The value field of the drawdown.
 * @param {string} drawdown.start - The start field of the drawdown.
 * @param {string} drawdown.end - The end field of the drawdown.
 * @returns {boolean} Returns true if all fields are non-empty strings, otherwise false.
 */
export const validateDrawdownFields = (drawdown) => {
  return drawdown.value !== "" && drawdown.start !== "" && drawdown.end !== "";
};

/**
 * Validates a pension row object to ensure all required fields are non-empty.
 *
 * @param {Object} row - The pension row object to validate.
 * @param {string} row.name - The name associated with the pension row.
 * @param {string} row.pensionName - The name of the pension.
 * @param {Object} row.fundValue - The fund value object.
 * @param {string|number} row.fundValue.value - The value of the fund.
 * @param {Object} row.contribution - The contribution object.
 * @param {string|number} row.contribution.value - The value of the contribution.
 * @param {string} row.atr - The attitude to risk value.
 * @returns {boolean} Returns true if all required fields are non-empty, otherwise false.
 */
export const validatePensionRow = (row) => {
  const { name, pensionName, fundValue, contribution, atr } = row;

  return (
    name !== "" &&
    pensionName !== "" &&
    fundValue.value !== "" &&
    contribution.value !== "" &&
    atr !== ""
  );
};
  